import { useState } from "react";
import DeliveryMap from "../../DeliveryMap";

export default function DetailsStep({
  fulfilment,
  form,
  setForm
}) {

  const updateField = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div style={{ marginBottom: 40 }}>
      <h3
        style={{
          fontSize: "14px",
          textTransform: "uppercase",
          color: "#C4773B",
          marginBottom: 20
        }}
      >
        Step 4 — Your Details
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "1fr 1fr",
          gap: 12,
          marginBottom: 12
        }}
      >
        <input
            placeholder="First Name"
            value={form.firstName}
            onChange={(e) =>
                setForm({
                ...form,
                firstName: e.target.value
                })
            }
            style={inputStyle}
        />

        <input
          placeholder="Last Name"
          value={form.lastName}
          onChange={(e) =>
                setForm({
                ...form,
                lastName: e.target.value
                })
            }
            style={inputStyle}
        />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "1fr 1fr",
          gap: 12
        }}
      >
        <input
          type="email"
          placeholder="Email Address"
          value={form.email}
          onChange={(e) =>
                setForm({
                ...form,
                email: e.target.value
                })
            }
          style={inputStyle}
        />

        <input
          placeholder="+254..."
          value={form.phone}
          onChange={(e) =>
                setForm({
                ...form,
                phone: e.target.value
                })
            }
          style={inputStyle}
        />
      </div>

      {fulfilment === "delivery" && (
  <>
    <div
      style={{
        marginTop: 32,
        marginBottom: 20,
        fontSize: "0.7rem",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        color: "#C4773B"
      }}
    >
      Delivery Address
    </div>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12
      }}
    >
      <input
        type="text"
        placeholder="Street Address"
        value={form.address}
        onChange={(e) =>
                setForm({
                ...form,
                address: e.target.value
                })
            }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Town / City"
        value={form.city}
        onChange={(e) =>
                setForm({
                ...form,
                city: e.target.value
                })
            }
        style={inputStyle}
      />

      <textarea
        placeholder="Additional delivery information (estate, landmark, building name, directions, etc.)"
        value={form.notes}
        onChange={(e) =>
                setForm({
                ...form,
                notes: e.target.value
                })
            }
        style={{
          ...inputStyle,
          minHeight: 100,
          resize: "vertical"
        }}
      />
    </div>

    <div
      style={{
        marginTop: 16,
        padding: 16,
        background:
          "rgba(196,119,59,0.08)",
        borderLeft:
          "3px solid #C4773B",
        fontSize: 13,
        lineHeight: 1.6,
        color: "#8B7355"
      }}
    >
      <strong
        style={{
          display: "block",
          color: "#1A1611",
          marginBottom: 6
        }}
      >
        Delivery Information
      </strong>

      Delivery fee is not included in
      the book price.
      <br />
      Someone from our team will
      contact you to arrange delivery
      and payment with the rider or
      courier.
    </div>
  </>
)}
    </div>
  );
}

const inputStyle = {
  padding: "12px 14px",
  border: "1px solid rgba(26,22,17,0.12)",
  background: "#fff",
  fontSize: 14,
  width: "100%"
};